import { BUTTON_POSITION } from "@toruslabs/base-controllers";
import { THEME_MODES } from "@web3auth/auth";

import TorusLogoDark from "../assets/torus-logo-dark.svg";
import TorusLogoLight from "../assets/torus-logo-light.svg";
import { EmbedInitParams } from "./interfaces";

export const LOCALE_EN = "en";
export const LOCALE_DE = "de";
export const LOCALE_JA = "ja";
export const LOCALE_KO = "ko";
export const LOCALE_ZH = "zh";
export const LOCALE_ES = "es";
export const LOCALE_FR = "fr";
export const LOCALE_PT = "pt";
export const LOCALE_NL = "nl";
export const LOCALE_EN_LABEL = "English";
export const LOCALE_DE_LABEL = "German (Deutsch)";
export const LOCALE_JA_LABEL = "Japanese (日本語)";
export const LOCALE_KO_LABEL = "Korean (한국어)";
export const LOCALE_ZH_LABEL = "Mandarin (中文)";
export const LOCALE_ES_LABEL = "Spanish (Español)";
export const LOCALE_FR_LABEL = "French (Français)";
export const LOCALE_PT_LABEL = "Portuguese (Português)";
export const LOCALE_NL_LABEL = "Dutch (Nederlands)";

export const SFA_KEY = "sfa";

export const BUILD_ENV = {
  production: "production",
  staging: "staging",
  testing: "testing",
  development: "development",
} as const;

export type BUILD_ENV_TYPE = (typeof BUILD_ENV)[keyof typeof BUILD_ENV];

export const CHECKOUT_URLS = {
  [BUILD_ENV.production]: "https://checkout.web3auth.io",
  [BUILD_ENV.staging]: "https://staging-checkout.web3auth.io",
  [BUILD_ENV.testing]: "https://develop-checkout.web3auth.io",
  [BUILD_ENV.development]: "https://develop-checkout.web3auth.io",
};

export const LOCALES = [
  {
    name: LOCALE_EN_LABEL,
    value: LOCALE_EN,
  },
  {
    name: LOCALE_DE_LABEL,
    value: LOCALE_DE,
  },
  {
    name: LOCALE_JA_LABEL,
    value: LOCALE_JA,
  },
  {
    name: LOCALE_KO_LABEL,
    value: LOCALE_KO,
  },
  {
    name: LOCALE_ZH_LABEL,
    value: LOCALE_ZH,
  },
  {
    name: LOCALE_ES_LABEL,
    value: LOCALE_ES,
  },
  {
    name: LOCALE_FR_LABEL,
    value: LOCALE_FR,
  },
  {
    name: LOCALE_PT_LABEL,
    value: LOCALE_PT,
  },
  {
    name: LOCALE_NL_LABEL,
    value: LOCALE_NL,
  },
];

export const ROUTES = {
  CHECKOUT: "Checkout",
  SWAP: "swap",
  TOKEN_DETAILS: "token-details",
  NFT_DETAILS: "nft-details",
  TRANSFER_TOKEN: "Send",
  SETTINGS: "Settings",
  ACTIVITY: "Activity",
  HOME: "Home",
  SIGN_TRANSACTION: "Sign Transaction",
  SIGN_MESSAGE: "Sign Message",
  LOGIN: "Login",
  START: "Start",
  END: "End",
  FRAME: "Frame",
  REDIRECT: "Redirect",
  REQUEST: "Request",
};

export const LAYOUT = {
  RAW: "RawLayout",
  BASIC: "BasicLayout",
  MAIN: "MainLayout",
};

export const TORUS_CONTROLLER_EVENTS = {
  LOGIN_RESPONSE: "login_response",
  STORE: "store",
  LOGOUT: "logout",
  CONFIRMATION_MODAL_SHOW: "confirmation_modal_show",
  CONFIRMATION_MODAL_RESULT: "confirmation_modal_result",
  CONFIRMATION_VIEW_SHOW: "confirmation_view_show",
  CONFIRMATION_VIEW_RESULT: "confirmation_view_result",
} as const;

export const DEFAULT_WHITELABEL: EmbedInitParams["whiteLabel"] = {
  buttonPosition: BUTTON_POSITION.BOTTOM_LEFT,
  hideNftDisplay: false,
  hideTokenDisplay: false,
  hideDefiPositionsDisplay: false,
  hideTransfers: false,
  hideTopup: false,
  hideReceive: false,
  hideSwap: false,
  hideShowAllTokens: false,
  hideWalletConnect: false,
  defaultPortfolio: "token",
  appName: "Web3Auth",
  logoDark: TorusLogoDark, // logo used on dark mode
  logoLight: TorusLogoLight, // logo used on light mode
  defaultLanguage: "en",
  mode: THEME_MODES.light,
  showWidgetButton: false,
};

export const TRANSACTION_TYPE_KEYS: { [key: string]: string } = {
  cancel: "portfolio.cancel",
  retry: "walletFrontend.retry",
  contractInteraction: "walletFrontend.contractInteraction",
  contractDeployment: "walletFrontend.contractDeployment",
  wasmBasedDeploy: "walletFrontend.wasmBasedDeploy",
  transaction: "walletFrontend.transaction",
  payment_transaction: "walletFrontend.paymentTxn",
  sentEther: "walletFrontend.sentEther",
  transfer: "walletFrontend.transfer",
  transferFrom: "walletFrontend.transferFrom",
  approve: "walletFrontend.approve",
  safeTransferFrom: "walletFrontend.safeTransferFrom",
  setApprovalForAll: "walletFrontend.setApprovalForAll",
  batch: "walletFrontend.batch",
  revokeDelegation: "walletFrontend.revokeDelegation",
};

export const SIGN_CONFIRM = {
  MESSAGE: "message",
  TRANSACTION: "transaction",
};

export type SIGN_CONFIRM_TYPE = (typeof SIGN_CONFIRM)[keyof typeof SIGN_CONFIRM];

export const SOLANA_CAIP_CHAIN_MAP: Record<string, string> = {
  "0x65": "5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
  "0x66": "4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
  "0x67": "EtWTRABZaYq6iMfeYKouRu166VU2xqa1",
} as const;
